<template>
  <div :class="$style.buttonGroup">
    <slot v-if="slots['default']" name="default" />
  </div>
</template>

<script setup lang="ts">
const slots = defineSlots<{
  default?(): unknown;
}>();
</script>

<style lang="scss" module>
@use "../styles/generated/figma_typo_mixins.scss" as FigmaTypoMixins;

.buttonGroup {
  display: inline-flex;
  align-items: flex-start;
  button {
    border-radius: 0px !important;
    &:first-child {
      border-radius: var(--border-radius-large) 0px 0px var(--border-radius-large) !important;
    }
    &:last-child {
      border-radius: 0px var(--border-radius-large) var(--border-radius-large) 0px !important;
    }
    // Neighbours overlap by one border so the divider between them stays 1px.
    & + button {
      margin-left: -1px;
    }
  }
}
</style>
